import apiClient from '../api'
import store from 'store'
import { history } from '../../index'
import { useSearchParams } from "react-router-dom";


export async function loginSocial(email, accessToken, userID, provider) {
  const params = {
    'email' : email,
    'accessToken' : accessToken,
    'userID' : userID,
    'provider': provider
  }
    return apiClient
    .post('/auth/loginSocial', params)
    .then(response => {
      if (response) {
        const  accessToken    = response.data.token;
        const  idUser         = response.data.id;
        const  Navigate       = response.data.Navigate;
        const  user_role       = response.data.user_role;
        if (accessToken) {
          store.set('AccessToken', accessToken);
        }
        if (idUser) {
          store.set('idUser', idUser);
          store.set('user', user);
          store.set('user_role', user_role);
        }

        if( Navigate != null )
        {
          if( history.location.pathname !== Navigate )
          {
            history.push(Navigate)
          }
        }
        return response.data;
      }
      return false
    })
    .catch(err => console.log(err))  
}

export async function login(email, password) {
    const data = {
      email:          email,
      password:       password,
      notification:  true,
      Navigate:      true,
    }
    // Skip auto error handling - saga will handle errors
    // Skip auto loading - saga shows its own loading message
    return apiClient
      .post('/auth/login', data, { 
        skipAutoErrorHandling: true,
        skipAutoLoading: true 
      })
      .then(response => {
        if (response) {
          return response.data;
        }
        return false
      })
      .catch(err => {
        // Re-throw error so saga can handle it
        throw err;
      })
  }

  
  export async function forgetpassword(email) {
    const params = {
      email: email
    };
    return apiClient
      .post('/auth/forget_password', 
        params
      )
      .then(response => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch(err => {
        console.log(err)
        return false
      })
  }

  // Send OTP for registration
  export async function sendRegistrationOTP(email) {
    const params = {
      email: email
    }

    return apiClient
      .post('/auth/send_registration_otp', params)
      .then(response => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch(err => console.log(err))
  }

  // Verify OTP for registration
  export async function verifyRegistrationOTP(email, otp) {
    const params = {
      email: email,
      otp: otp
    }

    return apiClient
      .post('/auth/verify_registration_otp', params)
      .then(response => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch(err => console.log(err))
  }

  // Legacy register function for backward compatibility
  export async function register(first_name, last_name, primaryEmail, mobile, password, web_pages, timezone,  makeNewUser = false ) {
    const params = new URLSearchParams();
    params.append('password', password);
    params.append('first_name', first_name);
    params.append('last_name', last_name);
    params.append('email', primaryEmail);
    params.append('mobile', mobile);
    params.append('web_pages', web_pages);
    params.append('timezone', timezone);
    params.append('makeNewUser', makeNewUser);
    
    return apiClient
      .post('/auth/register', params)
      .then(response => {
        if (response) {
          // const { accessToken } = response.data
          // if (accessToken) {
          //   store.set('AccessToken', accessToken)
          // }
          return response.data
        }
        return false
      })
      .catch(err => console.log(err))
  }

  // New comprehensive register function for multi-step registration
  export async function registerComprehensive(registrationData) {
    return apiClient
      .post('/auth/register', registrationData)
      .then(response => {
        if (response) {
          return response.data
        }
        return false
      })
      .catch(err => console.log(err))
  }
  
  
  export async function logout() {
    return apiClient
      .post('/auth/logout')
      .then(response => {
        if (response) {
          store.remove('AccessToken')
          store.remove('auth');    
          return response.data       
        }
    
        return false
      })
      .catch(err => console.log(err))
  }
  